import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment.development';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Obtener el token desencriptado
  const token = authService.getToken();
  
  console.log('🔑 Interceptor - URL:', req.url);
  console.log('🔑 Interceptor - Token encontrado:', token ? 'SÍ ✅' : 'NO ❌');
  
  if (token) {
    console.log('🔑 Token (primeros 50 chars):', token.substring(0, 50) + '...');
  }

  // Clonar la petición y agregar el token si existe
  let authReq = req;
  if (token) {
    authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
    console.log('✅ Header Authorization agregado');
  } else {
    console.warn('⚠️ No hay token disponible para agregar al request');
  }

  // Continuar con la petición y manejar errores
  return next(authReq).pipe(
    catchError((error) => {
      // Si el token expiró o es inválido (401)
      if (error.status === 401) {
        // Evitar bucle infinito: no procesar logout en peticiones de logout
        const isLogoutRequest = req.url.includes('/auth/logout');
        
        if (!isLogoutRequest && authService.isLoggedIn()) {
          console.error('❌ 401 - Token inválido o expirado');
          // Usar clearLocalSession directamente para evitar más peticiones HTTP
          authService.clearLocalSession();
        }
      }

      // Si hay un error de servidor (500)
      if (error.status === 500) {
        console.error('❌ 500 - Error del servidor:', error.message);
      }

      // Si hay un error de red
      if (error.status === 0 && environment.production) {
        console.error('❌ Error de conexión - Verifica tu internet o el servidor');
      }

      return throwError(() => error);
    })
  );
};
